<template>
  <van-popup :value="value" @input="input" position="center" round style="width:90vw">
    <div class="flex flex-col items-center p-4">
      <DeviceName :device-id="tagId" :device-name="deviceName" :legal="legalDevice"/>

      <div class="horizontal items-center w-full mt-4" v-if="legalDevice">

        <div class="vertical items-center justify-center flex-1">
          <van-image :src="flavorImage" fit="contain" height="151px"/>
        </div>


        <div class="flex-1" v-if="legalDevice">
          <HistoryCurve :max-power="10" :resistance="1.2" :power="power" :device-level="level"
              curve-color="#679AFF"
              :curve-line-color="[
             {offset:1,color:'rgba(0, 60, 255, 1)'},
             {offset:0.75,color:'rgba(108, 158, 255, 0.75)'},
             {offset:0,color:'rgba(255, 255, 255, 0)'}
          ]"/>
          <div class="mt-1">
            <van-loading v-if="loading" size="24px">Loading ingredient...</van-loading>
            <div class="vertical items-center consumer-info-wrap" v-else>
              <div class="flavor main-color text-center mt-3" v-if="flavorTag">{{ flavorTag }}</div>
              <div class="horizontal items-center mt-3">
                <div class="horizontal items-center">
                  <van-image :src="require('@/assets/icons/consumer/ic_liquid.svg')"/>
                  <span>{{oilPercent}}%</span>
                </div>
                <div class="horizontal items-center ml-3">
                  <van-image :src="require('@/assets/icons/consumer/ic_battery.svg')"/>
                  <span>{{batteryPercent}}%</span>
                </div>
              </div>
              <div class="text-12px mt-1 text-center">{{ ingredientText }}</div>
            </div>

          </div>
        </div>
      </div>

      <div v-if="showButton" class="flex flex-row items-center text-center gap-3 mt-10 w-full">
        <div @click="onWriteClick" class="flex-1 text-white write-btn"
            style="background: #121212">Complete
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import DeviceName from "@/components/home/DeviceName.vue";
import HistoryCurve from "@/views/HistoryCurve.vue";
import { mapState } from "vuex";
import { handleHexStringToUInt16 } from "@/util/utils";

export default {
  name: "PopupConsumerDeviceCurve",
  components: { HistoryCurve, DeviceName },
  props: {
    showButton: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: true
    },
    value: {
      type: Boolean,
      default: true
    },
    level: {
      type: Number,
      default: 1
    },
    ingredientText: {
      type: String,
      default: ""
    },
    deviceName: {
      type: String,
      default: ""
    },
    power: {
      type: Array,
      default: () => []
    },
    tagId: {
      type: String,
      default: ""
    },
    flavorImage: {
      type: String,
      default: ""
    },
    flavorTag: {
      type: String,
      default: ""
    },
    legalDevice: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  methods: {
    input(e) {
      this.$emit("input", e);
    },
    onWriteClick() {
      this.$emit("input", false);
    }
  },
  computed: {
    ...mapState("nfc", [
      "nfcDeviceOilBattery",
      "writerSetting",
      "typeOfDevice"
    ]),
    batteryPercent() {
      if (this.nfcDeviceOilBattery) {
        const currentVoltagesMax = 4000;
        const currentVoltagesMin = 3500;
        const currentVoltages = handleHexStringToUInt16(this.nfcDeviceOilBattery.battery);
        if (currentVoltages <= 100) {
          return currentVoltages
        }
        if (currentVoltages >= currentVoltagesMax) {
          return 100;
        } else if (currentVoltages <= currentVoltagesMin) {
          return 0;
        }
        //(4000-3400) / (4150-3400)
        return parseFloat((((currentVoltages - currentVoltagesMin) / (currentVoltagesMax - currentVoltagesMin)) * 100).toFixed(0));
      }
      return 0;
    },
    oilPercent() {
      if (this.nfcDeviceOilBattery) {
        if (this.isCartridge) {
          const { currentSecond, maxSecond } = this.nfcDeviceOilBattery;
          const currentSeconds = handleHexStringToUInt16(currentSecond);
          let maxSeconds = handleHexStringToUInt16(maxSecond);
          if (maxSeconds === 0) {
            maxSeconds = 1000;
          }
          return parseFloat(((maxSeconds - currentSeconds) / maxSeconds * 100).toFixed(0));
        }
        const { currentSecond, maxSecond } = this.nfcDeviceOilBattery;
        const currentSeconds = handleHexStringToUInt16(currentSecond);
        const maxSeconds = handleHexStringToUInt16(maxSecond);
        const idleSecond = maxSeconds - currentSeconds;
        if (idleSecond <= 0) {
          return 0;
        }

        return parseFloat((((idleSecond) / maxSeconds) * 100).toFixed(0));
      }
      return 0;
    }
  },
  mounted() {

  }
};
</script>

<style scoped lang="less">

.flavor-name-tags {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-x: scroll;

  .flavor-name {
    font-size: 15px;
  }

  .flavor-tag-content {
    margin-top: 10px;
    display: flex;
    flex: 1;
    font-size: 10px;
    flex-direction: row;
    align-items: center;
    overflow-x: scroll;

    .flavor-tag {
      border-radius: 8px;
      background: var(--modeActiveBackground) !important;
      color: var(--modeActiveTextColor) !important;
      padding: 4px 8px;
      margin-right: 4px;
    }
  }
}

.write-btn {
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.consumer-info-wrap {
  font-size: 12px;
  color: #333333;
}

.flavor {
  width: 112px;
  height: 25px;
  border-radius: 6px;
  background: #F1F6FF;
  font-size: 12px;
  line-height: 25px;
}

</style>